import React from 'react';
import {
  Card,
  Text,
  Button,
  Tabs,
  TabPanel,
  Icon,
  Segment,
  Bubble,
} from 'tea-component';

import SvgIcon from '@/pages/home/components/SvgIcon';
import '@/pages/dashboard/assets/scss/page/Overlay/components/cartContext.scss';
import { buildExcelColumns, exportExcel, formatNum, formatPercentNum, getRatioText, unitConversion } from "@/pages/dashboard/utils/utils";
import { useLocal } from '@/pages/dashboard/utils/customHook';

interface Props {
  data: {
    metricsName: string
    metricsDesc: string
    value: string | number
    dod: {
      value: string
      startTime: string
      endTime: string
      startValue: string
      endValue: string
    }
    sdlw: {
      value: string
      startTime: string
      endTime: string
      startValue: string
      endValue: string
    }
    change: {
      value: string
      startTime: string
      endTime: string
      startValue: string
      endValue: string
    }
  }
  timeType: string
  isChange: boolean
}

const MetricsCard = (props: Props) => {
  const { data, isChange, timeType } = props;
  const {
    metricsName,
    metricsDesc,
    value,
    dod,
    sdlw,
    change
  } = data ?? {}
  const { isEN, getLocalText } = useLocal();

  const statusMap: any = {
    up: {
      className: 'text-green',
      icon: (
        <SvgIcon className='overlay-card-body-icon' type="green-up-new" />
      )
    },
    down: {
      className: 'text-red',
      icon: (
        <SvgIcon className='overlay-card-body-icon' type="red-down-new" />
      )
    }
  }
  const statistics = (() => {
    if (timeType === 'Day') return getLocalText('dod')
    if (timeType === 'Week') return getLocalText('wow')
    if (timeType === 'Month') return getLocalText('mom')
  })()
  const contrast = (() => {
    if (timeType === 'Day') return getLocalText('sdlw')
    if (timeType === 'Week') return getLocalText('swlm')
    if (timeType === 'Month') return getLocalText('smly')
  })()
  const explainMap: any = {
    Day: ['Day on Day', 'Same Day Last Week'],
    Week: ['Week on Week', 'Same Week Last Month'],
    Month: ['Month on Month', 'Same Month Last Year'],
  }
  const explainArr = explainMap[timeType]

  return (
    <Card>
      <Card.Body
        className='overlay-card'
        title={
          <div className='overlay-card-title' style={{ marginBottom: '-10px' }}>
            <Bubble
              dark
              placement="top"
              style={{maxWidth:'341px'}}
              content={<div className='overlay-card-desc' dangerouslySetInnerHTML={{__html: metricsDesc}} />}
            >
              <div className='overlay-card-text'>{metricsName}</div>
            </Bubble>
          </div>
        }
      >
        <div className="overlay-card-body">
          <div className={`overlay-card-body-left overlay-card-body-left-${isChange?'change': ''}`}>
            <div className="overlay-card-body-num">{value}</div>
            <Bubble
              trigger="hover"
              dark
              placement="bottom-start"
              content={(isChange ? [change] : [dod, sdlw])?.map((item: any, index: any) => {
                const {
                  startTime,
                  endTime,
                  startValue,
                  endValue,
                } = item ?? {}

                const titleMap: any = {
                  0: <>{statistics} {explainArr && isEN && <Text className="bubble-desc">({explainArr[0]})</Text>}</>,
                  1: <>{contrast} {explainArr && isEN && <Text className="bubble-desc">({explainArr[1]})</Text>}</>,
                }

                return (
                  <div className="bubble-item" key={index}>
                    <div className="bubble-title">
                      {titleMap[index]}
                    </div>
                    <div className="bubble-flex">
                      <div className="bubble-text">
                        <div className="bubble-t">{startTime}</div>
                        <div className="bubble-b">{endTime}</div>
                      </div>
                      <div className="bubble-ct">VS</div>
                      <div className="bubble-text">
                        <div className="bubble-t">{startValue}</div>
                        <div className="bubble-b">{endValue}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            >
              <div className="overlay-card-body-flex">
                <div className="overlay-card-body-flex-item">
                  {
                    isChange ? (
                      <div className="overlay-card-body-text">{getLocalText('change')}</div>
                    ) : (
                      <>
                        <div className="overlay-card-body-text">{statistics}</div>
                        <div className="overlay-card-body-text">{contrast}</div>
                      </>
                    )
                  }
                </div>
                <div className="overlay-card-body-flex-rightitem">
                  {
                    isChange ? (
                      (() => {
                        const { text, status } = getRatioText(change?.value)
                        const { className, icon } = statusMap?.[status] ?? {}

                        return (
                          <div style={{ justifyContent: 'flex-start' }} className={`${className} overlay-card-body-textnum`}>
                            {
                              status === 'no' ? (
                                '-'
                              ) : (
                                <>
                                  {text}
                                  {icon}
                                </>
                              )
                            }
                          </div>
                        )
                      })()
                    ) : (
                      [dod?.value, sdlw?.value]?.map((data,index) => {
                        const { text, status } = getRatioText(data)
                        const { className, icon } = statusMap?.[status] ?? {}
  
                        return (
                          <div style={{ justifyContent: 'flex-start' }} className={`${className} overlay-card-body-textnum`} key={123}>
                            {
                              status === 'no' ? (
                                '-'
                              ) : (
                                <>
                                  {text}
                                  {icon}
                                </>
                              )
                            }
                          </div>
                        )
                      })
                    )
                  }
                </div>
              </div>
            </Bubble>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default MetricsCard